/**
 * After `seconds` (Monarch timeout units), runs `onComplete`. Returns a function that clears the timer.
 *
 * @param {string} _label Reserved for future logging / debugging
 * @param {number} seconds Same units as Monarch `timeout` (seconds)
 * @param {() => void} onComplete
 * @returns {() => void}
 */
export const scheduleChatTriggerDelay = (_label, seconds, onComplete) => {
  const id = setTimeout(onComplete, Math.max(0, Number(seconds) || 0) * 1000);
  return () => clearTimeout(id);
};
